<div class="beta-toggle-floating"
     cdkDrag
     [cdkDragDisabled]="!dragEnabled"

     cdkDragRootElement=".cs-toggle-user-preference-container">

    <!-- DRAGGABLE HEADER -->
    <div class="cs-d-flex align-items-center drag-area"
         cdkDragHandle>

        <!-- LEFT : DRAG HANDLE -->
        <span class="drag-handle"
              *ngIf="dragEnabled"
              title="Drag">
            <i class="fas fa-grip-vertical pr-9px"></i>
              <span class="toggle-text center-text">Ready to explore the beta view?</span>
        </span>


        <!-- RIGHT : TOGGLE -->
        <label class="toggle-label no-drag">
            <input type="checkbox"
                   [(ngModel)]="toggleSwitch"
                   (change)="setUserPropertyViewPreference()"
                   cdkDragDisabled />
            <span class="toggle-slider"></span>
        </label>

    </div>

    <!-- NOT DRAGGABLE : FEEDBACK FORM -->
    <div class="feedback-form no-drag"
         *ngIf="showFeedbackForm">

        <p class="beta-message">
            We're sorry to see you switch back. We'd love to know why so we can continue to improve the software
        </p>

        <div class="beta-reason-select">
            <select csSelect2
                    class="w-100"
                    [select2Config]="select2Config"
                    (onChange)="validateFeedback($event)"
                    cdkDragDisabled>
                <option value="">--Select reason--</option>
                <option *ngFor="let reason of reasons"
                        [value]="reason.id">
                    {{ reason.description }}
                </option>
            </select>
        </div>

        <textarea class="tall"
                  [(ngModel)]="comments"
                  placeholder="Your feedback"
                  cdkDragDisabled>
        </textarea>

        <div class="feedback-actions">
            <button class="beta-button"
                    [disabled]="!canSubmit"
                    (click)="submitFeedbackForm()"
                    cdkDragDisabled>
                Turn off the beta
            </button>
        </div>

    </div>
</div>
